<template>
  <div class="password-reset-complete-section">
    <h4 class="password-reset-complete-section__title">
      {{ $t('PasswordResetPage.CompletePage.title') }}
    </h4>
    <div
      class="password-reset-complete-section__message"
      v-html="$t('PasswordResetPage.CompletePage.message')"
    ></div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

export type DataType = {
  title: string
  message: string
}

/**
 * パスワードリセット完了 セクション
 */
export default defineComponent({
  name: 'PasswordResetCompleteSection',
  data(): DataType {
    return {
      /**
       * タイトル
       */
      title: '',
      /**
       * メッセージ
       */
      message: '',
    }
  },
})
</script>

<style lang="scss" scoped>
.password-reset-complete-section {
  width: 100%;
  padding: 80px min(#{convertPXtoVW(14)}, 14px) 0;
  text-align: center;

  &__title {
    @include fontSetTextMedium(17);
  }

  &__message {
    margin-top: 24px;
    @include fontSetTextMedium();

    letter-spacing: 0.04em;
  }
}
</style>
